import remove from 'lodash/remove';
import api from '@/api';

export default {
  namespaced: true,

  state: {
    projects: [],
    currentProject: null,
  },
  getters: {
    // 大屏选中项目
    screenProject: (state) => {
      return (projectId) => {
        const project = state.projects.find(item => item.id === projectId);
        return project;
      };
    },
    currentProjectTitle: state => state.currentProject && state.currentProject.name,
  },

  actions: {
    async InitProjects({ state, commit, dispatch }) {
      await dispatch('GetProjects', { reload: true });
      let currentProject = null;
      if (sessionStorage.currentProject) {
        currentProject = JSON.parse(sessionStorage.currentProject);
      } else if (state.projects.length) {
        currentProject = state.projects[0];
      }

      if (currentProject && currentProject.id) {
        commit('SET_CURRENT_PROJECT', currentProject);
      }
    },
    async GetProjects({ state, commit }, payload) {
      let reload = false;
      let showLoading = true;
      if (typeof payload === 'object') {
        reload = payload.reload;
        showLoading = Object.keys(payload).includes('showLoading') ? payload.showLoading : showLoading;
      }

      if (state.projects && state.projects.length && !reload) {
        return state.projects;
      }

      const { projects } = await api.project.getProjects({}, { showLoading });
      commit('SET_PROJECTS', projects);
      return projects;
    },
    async AddProject({ commit }, projectForm) {
      const { project } = await api.project.addProject({ ...projectForm });
      commit('ADD_PROJECT', project);
      return project;
    },
    async UpdateProject({ commit }, projectForm) {
      const { project } = await api.project.putProject({ ...projectForm });
      commit('UPDATE_PROJECT', project);
      return project;
    },
    async DeleteProject({ state, commit, dispatch }, project) {
      await api.project.deleteProject({ projectId: project.id });
      commit('DELETE_PROJECT', project);
      await dispatch('GetProjects', { reload: true });
      const currentProject = state.projects[0];
      if (currentProject && currentProject.id) {
        commit('SET_CURRENT_PROJECT', currentProject);
      }
    },

    // 获取项目成员
    async GetMembers(_, { projectId }) {
      const { members } = await api.project.getMembers({ projectId });
      return members;
    },
    // 设置项目成员
    async SetMembers(_, { projectId, memberIds }) {
      await api.project.putMembers({ projectId, memberIds });
    },
  },
  mutations: {
    SET_PROJECTS(state, projects) {
      state.projects = projects;
    },
    ADD_PROJECT(state, project) {
      const { projects } = state;
      state.projects = [...projects, project];
    },
    UPDATE_PROJECT(state, project) {
      const { projects } = state;
      const target = projects.find(item => item.id === project.id);

      if (target) {
        Object.assign(target, project);
        state.projects = [...projects];
      }
    },
    DELETE_PROJECT(state, project) {
      const { projects } = state;
      remove(projects, item => item.id === project.id);
      state.projects = [...projects];
    },
    SET_CURRENT_PROJECT(state, project) {
      state.currentProject = project;
      sessionStorage.setItem('currentProject', JSON.stringify(project));
    },
    SWITCH_PROJECT(state, projectId) {
      const { projects } = state;
      const project = projects.find(item => item.id === +projectId);
      if (project) {
        state.currentProject = project;
        sessionStorage.setItem('currentProject', JSON.stringify(project));
      } else {
        console.warn('Not Found Project', projectId);
      }
    },
  },
};
